module.exports = __webpack_public_path__ + "img/img27.efd8a0c3.jpg";